// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.changePass_cardWrapper__RStxK{
    display: flex;
    width: 100%;
    height: 50vh;
    font-family: "Montserrat", sans-serif;
    justify-content: center;
    align-items: center;
}
.changePass_card__pgJLc{
    padding: 15px;
    width: 400px;
    font-family: "Montserrat", sans-serif;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/changePass/changePass.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,wFAAwF;IACxF,mBAAmB;AACvB","sourcesContent":[".cardWrapper{\n    display: flex;\n    width: 100%;\n    height: 50vh;\n    font-family: \"Montserrat\", sans-serif;\n    justify-content: center;\n    align-items: center;\n}\n.card{\n    padding: 15px;\n    width: 400px;\n    font-family: \"Montserrat\", sans-serif;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardWrapper": `changePass_cardWrapper__RStxK`,
	"card": `changePass_card__pgJLc`
};
export default ___CSS_LOADER_EXPORT___;
